"use strict";
exports.__esModule = true;
exports.doLargeBitwiseOp = function (operands, bitOperator) {
    var operatorFunction = function (previous, current) {
        switch (bitOperator) {
            case "|":
                return previous | current;
            case "&":
                return previous & current;
        }
    };
    var highOperands = operands.map(function (element) {
        return element * Math.pow(2, -32);
    });
    return ((highOperands.reduce(operatorFunction) >>> 0) * Math.pow(2, 32) +
        (operands.reduce(operatorFunction) >>> 0));
};
//# sourceMappingURL=Helpers.js.map